// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    organizationId: z.string().min(1).max(21),
    emailDomain: z.string().min(1).max(128),
});
const guard = z.object({
    tenantId: z.string().max(21),
    organizationId: z.string().min(1).max(21),
    emailDomain: z.string().min(1).max(128),
});
export const OrganizationJitEmailDomains = Object.freeze({
    table: 'organization_jit_email_domains',
    tableSingular: 'organization_jit_email_domain',
    fields: {
        tenantId: 'tenant_id',
        organizationId: 'organization_id',
        emailDomain: 'email_domain',
    },
    fieldKeys: [
        'tenantId',
        'organizationId',
        'emailDomain',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
